import type { FetchVinDecodeResponse } from '@makemydeal/dr-shared-types';

export const extractTrimFromVehicles = (
    vehicles: FetchVinDecodeResponse,
    isPreserveCrmTradeVehicleInfoEnabled = false
): { name: string; id: number }[] => {
    return vehicles.map((result: FetchVinDecodeResponse[0]) => ({
        name: isPreserveCrmTradeVehicleInfoEnabled
            ? result.trim.normalizedName || ''
            : extractTrimFromVehicleTitle(result.title.split(' ')),
        id: result.trim.normalizedTrimId
    }));
};

export const extractTrimFromVehicleTitle = (title: string[]): string => {
    return title.slice(3, title.length).join(' ');
};
